import { Component, Input, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'

@Component({
    selector: 'case-datetime-yield',
    template: `
    {{ datetime | date : 'dd/MM/yy' }}
    <p class="my-0 content is-small has-text-grey-dark">
      {{ datetime | date : 'H:mm:ss' }}
    </p>
  `,
    standalone: true,
    imports: [CommonModule]
})
export class DatetimeYieldComponent {
  @Input() datetime: Date
}
